/**
 * Strip internal control tags from message content.
 * These tags are parsed by the backend and stored in separate fields
 * (questions_data, confirmation_button_data, etc.). This is a safety
 * net for any cases where tags leak through to the frontend.
 */
export function removeControlTags(content: string): string {
  return content
    .replace(/<implementation_plan>/gi, '')
    .replace(/<\/implementation_plan>/gi, '')
    .replace(/<level_upgrade_suggestion>.*?<\/level_upgrade_suggestion>/gi, '')
    .replace(/<questions_superseded\s*\/?>/gi, '')
    .replace(/<\/questions_superseded>/gi, '')
    .replace(/<next_step_suggestions>[\s\S]*?<\/next_step_suggestions>/gi, '')
    .replace(/<break_time\s*\/?>/gi, '')
    .replace(/<report>[\s\S]*?<\/report>/gi, '')
    .replace(/<StructuredOutput>[\s\S]*?<\/StructuredOutput>/gi, '')
    .replace(/<confirmation_button>[\s\S]*?<\/confirmation_button>/gi, '')
    .replace(/<confirmation_button>[\s\S]*$/gi, '')
    .replace(/<clarifying_questions>[\s\S]*?<\/clarifying_questions>/gi, '')
    .replace(/<clarifying_questions>[\s\S]*$/gi, '')
}
